import AdminListPage from "./components/AdminListPage";
export default function TerimaanList() {
	return (
		<AdminListPage
			title="Senarai Terimaan"
			endpoint="/admin/terimaan"
		/>
	);
}
